<template>
  <div class="l-col-12@md">
    <div class="l-row">
      <form-group label="Tipo de preço" :columns="3" :required="true">
        <select v-model="input.type" class="form-select" @change="onChangePriceType" :disabled="block">
          <option :value="null">Selecione</option>
          <option v-for="priceType in priceTypeDI" :value="priceType">
            {{ priceType === 'source' ? $t('priceTypeModule.label') + $t(moduleLabel) : $t(priceType).label }}
          </option>
        </select>
      </form-group>

      <form-group label="Percentual" v-if="isTypePercent" :columns="1" :required="true">
        <div class="form-flex">
          <input class="form-input" type="text" v-model="percent">
          <span class="form-addon">%</span>
        </div>
      </form-group>

      <form-group label="Valor fixo" v-if="isTypeFixedValue" :columns="3" :required="true">
        <money v-model="fixedValue" v-bind="money" class="form-input"/>
      </form-group>

      <form-group label="Preço Atual Fonte" v-if="isTypePercent" :columns="2">
        <div class="form-control has-iconRight">
          <money class="form-input" v-bind="money" type="text" v-model="source.current" :disabled="true"/>
          <span class="form-iconRight">
             <module-icon :identifier="module.identifier"/>
          </span>
        </div>
      </form-group>

      <form-group label="Preço antigo" :columns="3" :required="true">
        <money v-model="previous" v-bind="money" class="form-input" :disabled="disabled || block"/>
      </form-group>

      <form-group label="Preço atual" :columns="3" :required="true">
        <money v-model="current" v-bind="money" class="form-input" :disabled="disabled || block"/>
      </form-group>
    </div>
  </div>
</template>

<script>
  import { Money } from 'v-money'
  import { floor } from 'lodash'
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'
  import ModuleIcon from '@/components/template/ModuleIcon'

  export default {
    inject: ['priceTypeDI'],
    data: () => ({
      disabled: true,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      previous: 0.0,
      current: 0.0,
      percent: null,
      previousWithPercent: null,
      currentWithPercent: null,
      fixedValue: 0,
      isTypeFixedValue: false,
      isTypePercent: false,
      currentCustom: null
    }),
    props: {
      block: {
        type: Boolean,
        required: false,
        default: false
      },
      errors: {
        type: Array,
        required: false
      },
      input: {
        type: Object,
        required: true
      },
      sku: {
        type: String,
        default: ''
      },
      module: {
        type: Object,
        default: null
      }
    },
    async mounted () {
      if (this.input.type === '' || this.input.type === undefined || this.input.type === null) {
        this.input.type = 'source'
      }

      if (this.input.type === 'source') {
        this.source = {
          previous: this.input.previous,
          current: this.input.current
        }
      } else if (this.sku !== '') {
        const product = await api.getProductBySku(this.module.type, this.module.identifier, this.sku)
        this.source = {
          previous: product.variations[0].previousPrice,
          current: product.variations[0].currentPrice
        }

        if (this.input.type === 'percent') {
          this.percent = this.input.auxiliary
        } else if (this.input.type === 'fixedValue') {
          this.fixedValue = this.input.auxiliary
        }
      }

      if (this.input.type === 'custom') {
        this.currentCustom = this.input.current
      }

      this.onChangePriceType()
    },
    methods: {
      onChangePriceType () {
        this.previous = this.input.previous
        this.current = this.input.current

        if (this.currentCustom !== null) {
          this.current = this.currentCustom
        }

        if (this.input.type === 'source') {
          this.previous = this.source.previous
          this.current = this.source.current
        }

        if (
          this.input.type === 'source' ||
          this.input.type === 'percent' ||
          this.input.type === 'fixedValue' ||
          this.input.type === 'null' ||
          this.input.type === null
        ) {
          this.disabled = true
        } else {
          this.disabled = false
        }

        this.isTypePercent = false
        this.isTypeFixedValue = false
        if (this.input.type === 'percent') {
          this.previousWithPercent = this.previous
          this.currentWithPercent = this.current
          this.isTypePercent = true
        } else if (this.input.type === 'fixedValue') {
          this.isTypeFixedValue = true
        } else {
          this.input.auxiliary = null
          this.percent = null
        }
      },
      round (number) {
        return floor(number * 100) / 100
      }
    },
    computed: {
      moduleLabel () {
        if (this.module == null) {
          return 'module.label'
        }

        return this.module.identifier + '.label'
      }
    },
    components: {
      FormGroup,
      Money,
      ModuleIcon
    },
    watch: {
      previous (val) {
        this.input.previous = val
      },
      current (val) {
        this.input.current = val
      },
      percent (val) {
        this.previous = this.round(this.source.previous + (this.source.previous * (val / 100)))
        this.current = this.round(this.source.current + (this.source.current * (val / 100)))

        this.input.auxiliary = val
      },
      fixedValue (val) {
        this.previous = 0
        if (this.source.previous > 0) {
          this.previous = this.source.previous + val
        }

        this.current = this.source.current + val

        this.input.auxiliary = val
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ProductPriceUnique.vue?3d62afc4